/* eslint-disable no-template-curly-in-string */
import * as yup from "yup";
import gPhoneNumber from "google-libphonenumber";

const phoneUtil = gPhoneNumber.PhoneNumberUtil.getInstance();

const YUP_PHONE_METHOD = "phone";
const CLDR_REGION_CODE_SIZE = 2;
const DEFAULT_COUNTRY_CODE = "TR";

const isValidCountryCode = (countryCode: any) =>
  typeof countryCode === "string" && countryCode.length === CLDR_REGION_CODE_SIZE;

yup.addMethod(
  yup.string,
  YUP_PHONE_METHOD,
  function yupPhone(this: any, { countryCode, strict = false, message = "" }: any = {}) {
    const errMsg =
      typeof message === "string" && message
        ? message
        : isValidCountryCode(countryCode)
          ? `Bu alan, ${countryCode} bölgesi için geçerli bir telefon numarası olmalı`
          : "Bu alan geçerli bir telefon numarası olmalı";

    return this.test(YUP_PHONE_METHOD, errMsg, (value: any) => {
      if (!isValidCountryCode(countryCode)) {
        // if not valid countryCode, then set default country to DEFAULT_COUNTRY_CODE
        countryCode = DEFAULT_COUNTRY_CODE;
        strict = false;
      }

      try {
        const phoneNumber = phoneUtil.parseAndKeepRawInput(value, countryCode);

        if (!phoneUtil.isPossibleNumber(phoneNumber)) {
          return false;
        }

        const regionCodeFromPhoneNumber = phoneUtil.getRegionCodeForNumber(phoneNumber);

        return strict
          ? phoneUtil.isValidNumberForRegion(phoneNumber, countryCode)
          : phoneUtil.isValidNumberForRegion(phoneNumber, regionCodeFromPhoneNumber);
      } catch {
        return false;
      }
    });
  }
);

yup.addMethod(yup.object, YUP_PHONE_METHOD, function yupPhone(this: any) {
  const errMsg = "validations:string.phone";

  return this.test(YUP_PHONE_METHOD, errMsg, function test(phone: any) {
    if (phone.value === undefined || phone.value === "") {
      return true;
    }

    const { value } = phone;
    const countryCode = phone.country?.countryCode?.toUpperCase();

    try {
      const phoneNumber = phoneUtil.parseAndKeepRawInput(value, countryCode);

      if (!phoneUtil.isPossibleNumber(phoneNumber)) {
        return false;
      }

      const regionCodeFromPhoneNumber = phoneUtil.getRegionCodeForNumber(phoneNumber);

      return phoneUtil.isValidNumberForRegion(phoneNumber, regionCodeFromPhoneNumber);
    } catch {
      return false;
    }
  });
});
